import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=6be22556&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=ts"
export * from "./SiteHeader.vue?vue&type=script&lang=ts"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=6be22556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be22556",
  null
  
)

export default component.exports